module.exports = __webpack_public_path__ + "static/media/Michelle Downes.6f1f4895.png";